import axios from 'axios';
export * from './apiAttachment';
export * from './apiCatalogues'; 
export * from './apiMessages'; 
export * from './apiForm'; 
export * from './apiReports';
export * from './apiComplements';

export const host = "https://api.ethicsglobal.com/";
export const baseURL = `${host}`;
export const apiCall = axios.create({ baseURL });
